import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

function PaidUsdtRequest() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  // const { userId } = useSelector((state) => state.Auth);
  //   const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "";

  const [loader, setloader] = useState(false);
  const [TotalBet, setTotalBet] = useState("0");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(50);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(user);

  const referral_API = async () => {
    setloader(true);
    try {
      let responceRight = await API?.post(
        `GetPaidFundRequestList`,
        {
          uid: search.substring(2),
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      responceRight = responceRight?.data?.data[0];
      //console.log("res", responceRight);

      setleftreferralApi([]);
      let arrayLeft = [];
      let totalAmount = 0;

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          UserId: `${item.uid}`,
          amount: item.amount,
          f_name: item.f_name,
          accountnumber: item.accountnumber,
          userAddress: item.userAddress,
          utrno: item.utrno,
          date: item.date,
          adate: item.adate,
          Ftype: item.Ftype,
          remark: item.remark,
          statuss:
            item.statuss === "Approved" ? (
              <span style={{ color: "green" }}>{item.statuss}</span>
            ) : (
              <span style={{ color: "red" }}>{item.statuss}</span>
            ),
        });

        totalAmount =
          totalAmount + (item.status === "SUCCESS" ? item.amount : 0);
      });

      setleftreferralApi(arrayLeft);
      setTotalBet(totalAmount);
    } catch (error) {
      console.log("Error While calling Myteam API", error);
      if (
        error.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
    setloader(false);
  };

  const referral_API_Export = async () => {
    setloader(true);
    try {
      let responceRight = await API?.post(
        `GetPaidFundRequestList`,
        {
          uid: search.substring(2),
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight?.data?.data[0];
      let arrayLeft = [];

      Array.isArray(responceRight) &&
        responceRight.forEach((item, index) => {
          arrayLeft.push({
            sr: index + 1,
            UserId: `NC${item.uid}`,
            name: item.f_name,
            amount: item.amount,
            Ftype: item.Ftype,
            "Account Number": `'${item.accountnumber}`,
            utrno: item.utrno,
            Rdate: item.date,
            "Approve date": item.adate,
            remark: item.remark,
            statuss: item?.statuss,
          });
        });

      const fileName = `USDTDepositHistory`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      console.log("Error While calling Myteam API", error);
      if (
        error.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
    setloader(false);
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "UserId" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Type", accessor: "Ftype" },

      { Header: "Txn No", accessor: "utrno" },
      //{ Header: "Name", accessor: "f_name" },
      //{ Header: "Address", accessor: "accountnumber" },
      { Header: "Amount", accessor: "amount" },
      { Header: "User Address", accessor: "userAddress" },
      //{ Header: "UPI Type", accessor: "upitype" },
      //{ Header: "UPI Id", accessor: "upinumber" },
      { Header: "Requested Date", accessor: "date" },
      { Header: "Status", accessor: "statuss" },
      { Header: "Approved Date", accessor: "adate" },
      { Header: "Remark", accessor: "remark" },
    ],
  });

  return (
    <div>
      <Navbar />
       {userId === "1" ? (
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">
                      Confirm Wallet Change Request
                    </h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <form>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              onChange={(e) => setSearch(e.target.value)}
                              value={search}
                              className="form-control"
                              placeholder="Enter User Id, Mobile Or Email"
                              style={{ border: "1px solid silver" }}
                            />
                          </div>
                          <div className="col-sm-1">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              className="btn btn-lg btn-primary"
                              value="Search"
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API_Export()}
                              className="btn btn-lg btn-primary"
                              value="Export To Excel"
                            />
                          </div>
                        </form>
                        {/* <div
                          className="col-sm-4"
                          style={{ "margin-top": "10px" }}
                        >
                          <h4 className="panel-title">
                            Total Deposit Amount : {TotalBet}
                          </h4>
                        </div> */}
                      </div>

                      <div className="row">
                        <div className="panel-heading">
                          <h4 className="panel-title"></h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {loader && <Spinner />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ) : (
        <>
          <div class="content-page">
            <div class="content">
              <div class="row">
                <div class="col-md-12">
                  <div class="panel panel-primary">
                    <div class="panel-heading">
                      <h4 class="panel-title">Confirm Wallet Change </h4>
                    </div>
                    <div className="text-center mt-5">
                      <h3>You are not authorized to access this page.</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PaidUsdtRequest;
